/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
const accordions = document.querySelectorAll(".accordion-inner");
        const accordionImages = document.querySelector(".accordion_images"); // Get the accordion_images container

        const openAccordion = (accordion) => {
            const content = accordion.querySelector(".accordion-content");
            accordion.classList.add("accordion_active");
            content.style.maxHeight = content.scrollHeight + "px";
        };

        const closeAccordion = (accordion) => {
            const content = accordion.querySelector(".accordion-content");
            accordion.classList.remove("accordion_active");
            content.style.maxHeight = null;
        };

        const activateImages = (index) => {
            const images = accordionImages.querySelectorAll("img");
            images.forEach((img, i) => {
                if (i === index) {
                    img.classList.add("active");
                } else {
                    img.classList.remove("active");
                }
            });
        };

        accordions.forEach((accordion, index) => {
            const intro = accordion.querySelector(".accordion-header");
            const content = accordion.querySelector(".accordion-content");

            intro.onclick = () => {
                if (!content.style.maxHeight) {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                    activateImages(index);
                }
            };
        });

        //default click first accordion
        const firstAccordion = document.querySelectorAll(".accordion-header")[0];
        firstAccordion.click();

/* eslint-enable no-console */
